module.exports = __webpack_public_path__ + "static/media/vishwaa_img_.98340d57.png";